import { render, staticRenderFns } from "./DebugLexerParserOutput.vue?vue&type=template&id=f40e589a&scoped=true"
import script from "./DebugLexerParserOutput.vue?vue&type=script&lang=js"
export * from "./DebugLexerParserOutput.vue?vue&type=script&lang=js"
import style0 from "./DebugLexerParserOutput.vue?vue&type=style&index=0&id=f40e589a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40e589a",
  null
  
)

export default component.exports